export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en', 'ja', 'de', 'pt-BR', 'es'];

export const UNANNOUNCED_LOCALES = ['fr-FR'];
